module.exports = __webpack_public_path__ + "static/img/pic1.2b32b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic1.jpg
// module id = U6gL
// module chunks = 0